import format from "string-template";
import { REGEX_EXPS } from "utils/constants";
import { stripAllSpaces } from "utils/helpers/validations";
import * as yup from "yup";

const SIRET_LENGTH = 14;

const validation = (messages) =>
  yup.object().shape({
    company: yup.object().shape({
      siret: yup
        .string()
        .nullable()
        .transform(stripAllSpaces)
        .length(
          SIRET_LENGTH,
          format(messages.EXACT_LENGTH, { length: SIRET_LENGTH }),
        )
        .required(messages.REQUIRED),
      legalName: yup.string().nullable().required(messages.REQUIRED),
      legalForm: yup.string().nullable().required(messages.REQUIRED),
      street: yup.string().nullable().required(messages.REQUIRED),
      zipCode: yup
        .string()
        .nullable()
        .matches(REGEX_EXPS.zipCode, messages.INVALID_VALUE)
        .required(messages.REQUIRED),
      city: yup.string().nullable().required(messages.REQUIRED),
      phone: yup
        .string()
        .nullable()
        .transform(stripAllSpaces)
        .matches(REGEX_EXPS.phone, messages.INVALID_VALUE)
        .required(messages.REQUIRED),
      email: yup
        .string()
        .nullable()
        .email(messages.EMAIL)
        .required(messages.REQUIRED),
    }),
  });

export default validation;
